export default __webpack_public_path__ + "static/router_b.57f245d7f4b6268684d1466e344f8e1f.png";